import { styled } from "@mui/material";
import { DataGrid, DataGridProps, gridClasses, GridPagination } from "@mui/x-data-grid";
import { ROWS_PER_PAGE } from "../../utils/constants";
import TablePagination from "../TablePagination";

interface IAGDataGridProps extends DataGridProps {
	hideLastSeparator?: boolean;
	hideAllSeparators?: boolean;
	darkTheme?: boolean;
}

const PaginationComponent = (props: any) => (
	<GridPagination
		{...props}
		ActionsComponent={TablePagination}
		labelDisplayedRows={() => <></>}
		classes={{ spacer: "grid-pagination-spacer-custom" }}
		sx={{ "&.MuiTablePagination-root": { flexGrow: 0 } }}
	/>
);

export const AGDataGrid = styled((props: IAGDataGridProps) => (
	<DataGrid
		disableRowSelectionOnClick
		disableColumnMenu
		rowSpacingType="border"
		density="compact"
		columnHeaderHeight={80}
		pageSizeOptions={[ROWS_PER_PAGE]}
		slots={{ pagination: PaginationComponent }}
		slotProps={{ footer: { sx: { justifyContent: "center" } } }}
		hideFooter={props.paginationMode === "server" && (props.rowCount ?? 0) <= ROWS_PER_PAGE}
		{...props}
	/>
))(({ theme, hideLastSeparator, hideAllSeparators, darkTheme }) => {
	let lastColumnSeparatorSelector = "";

	if (hideLastSeparator) {
		lastColumnSeparatorSelector = ":not(:nth-last-of-type(4))";
	}

	return {
		[`&.${gridClasses.root}`]: {
			borderRadius: "5px",
			backgroundColor: "white"
		},
		[`& .${gridClasses.columnSeparator}`]: {
			display: "none"
		},
		[`& .${gridClasses.virtualScrollerContent}`]: {
			minHeight: "36px"
		},
		[`& .${gridClasses.columnHeader}`]: {
			backgroundColor: darkTheme ? theme.palette.primary.main : theme.palette.primary.light,
			color: darkTheme ? "white" : "#3D3D3D",
			[`&:not(:nth-last-of-type(3))${lastColumnSeparatorSelector}::after`]: hideAllSeparators
				? {}
				: {
						content: "''",
						position: "absolute",
						right: 0,
						width: "2px",
						height: "60%",
						backgroundColor: "#00000026"
				  }
		},
		[`& .${gridClasses.row}.gray-background`]: {
			backgroundColor: theme.palette.grey[200]
		}
	};
});
